import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getEtazhiBlackFridayPromoOffers } from 'shared/actions/etazhiBlackFriday';
import {
  selectEtazhiBlackFridayPromoOffers,
  selectIsEtazhiBlackFridayFilterEnabled,
} from 'shared/selectors/etazhiBlackFriday';

import type { TThunkDispatch } from 'shared/types/redux';

export function useGetPromoOffers(shouldFetchPromoOffers: boolean, isEnabledByRegionFetched: boolean) {
  const dispatch = useDispatch<TThunkDispatch>();
  const isBlackFridayFilterEnabled = useSelector(selectIsEtazhiBlackFridayFilterEnabled);
  const promoOffers = useSelector(selectEtazhiBlackFridayPromoOffers);
  const [isFetched, setIsFetched] = React.useState(false);

  React.useEffect(() => {
    // До проверки на регион не запрашиваем офферы
    if (isFetched || !isEnabledByRegionFetched) {
      return;
    }

    if (isBlackFridayFilterEnabled || !shouldFetchPromoOffers) {
      setIsFetched(true);

      return;
    }

    dispatch(getEtazhiBlackFridayPromoOffers()).then(() => {
      setIsFetched(true);
    });
  }, [dispatch, isBlackFridayFilterEnabled, shouldFetchPromoOffers, isFetched, isEnabledByRegionFetched]);

  return { isFetched, hasData: !!promoOffers?.length };
}
